import React from 'react';
const UserAvatarPopoverButtonsContext = React.createContext(true);
UserAvatarPopoverButtonsContext.displayName = 'UserAvatarPopoverButtonsContext';
export default UserAvatarPopoverButtonsContext;
